import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../../slice';
import {
  selectMappedFieldsFilteredByCulture,
  selectSingleFieldOnMap,
  selectSingleFieldOnMapFieldId,
} from '../../../slice/selectors';
import DisabledField from '../../fields/DisabledField/DisabledField';

import { Field } from '../../fields/Field/Field';

interface IProps {}

const SingleFieldOnMap = (props: IProps) => {
  const mappedField = useSelector(selectSingleFieldOnMap);
  const fieldId = useSelector(selectSingleFieldOnMapFieldId);
  const mappedFields = useSelector(selectMappedFieldsFilteredByCulture);

  const dispatch = useDispatch();
  const { actions } = useMapSlice();

  useEffect(() => {
    if (fieldId) {
      dispatch(actions.zoomSingleFieldMap());
    }
  }, [dispatch, actions, fieldId]);

  if (!mappedField) {
    return null;
  }

  return (
    <>
      <Field mappedField={mappedField} isSelected={false} />
      {mappedFields.map(field => {
        if (field.id === mappedField.id) {
          return null;
        }

        return <DisabledField mappedField={field} key={field.id} />;
      })}
    </>
  );
};

export default SingleFieldOnMap;
